var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wl-use-wallet"},[_c('wallet-box-1'),_c('wallet-box-2'),_c('wallet-box-3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }